<p>
  <strong>Safra: </strong>
  {{::recommendation.safra.descricao}}
  <br>
  <strong>Previsto: </strong>
  {{::recommendation.data_inicio | date:'dd/MM/yyyy'}}  até {{::recommendation.data_termino | date:'dd/MM/yyyy'}}
  <br>
  <strong>Recomendante: </strong>
  {{::recommendation.recomendante.nome_completo | capitalize}}
</p>

<strong>Propriedade: </strong>{{::recommendation.propriedade.descricao | uppercase}}
<br>
<strong>Talhões: </strong>
<span ng-repeat="gleba in recommendation.glebas track by $index">
  <span ng-show="$index > 0">, </span>
  {{::gleba.descricao | uppercase}} ({{::gleba.area_recomendada || 0 | number:1}} ha)
</span>

<table class="table no-padding recomendacao">
  <thead>
    <tr>
      <th class="no-padding-left">Produto</th>
      <th class="text-right">Dose</th>
      <th class="text-right">Total</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="produto in ::recommendation.produtos track by $index">
      <td class="no-padding-left vertical-middle">{{::produto.produto.descricao}}</td>
      <td class="text-right">{{::produto.qt_dose | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}/ha</td>
      <td class="text-right">{{::produto.qt_total | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}</td>
    </tr>
  </tbody>
</table>

<p class="list-group-item-text" ng-show="recommendation.parametro.velocidade_minima || recommendation.parametro.velocidade_maxima">
  <strong>Velocidade: </strong>{{::recommendation.parametro.velocidade_minima | number:0}} km/h à {{::recommendation.parametro.velocidade_maxima | number:0}} km/h
</p>
<p class="list-group-item-text" ng-show="recommendation.parametro.velocidade_maxima_vento">
  <strong>Vento: </strong>{{::recommendation.parametro.velocidade_maxima_vento | number:0}} km/h
</p>
<p class="list-group-item-text" ng-show="recommendation.parametro.observacoes">
  <strong>Observações: </strong>{{::recommendation.parametro.observacoes}}
</p>

<div class="signatures">
  <print-signature label="Recomendante" name="recommendation.recomendante.nome_completo"></print-signature>
  <print-signature label="Responsável" name="recommendation.responsavel.nome_completo"></print-signature>
</div>
